import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { getCurrentUser } from '../../selectors/userSelectors';
import { getCurrentLesson } from '../../selectors/lessonSelectors';
import LessonTypeformSurvey from './LessonTypeformSurvey';
import { extractTypeformId } from '../../utils/extractTypeformId';

function LessonTypeformSurveyContainer(props) {
  const { lesson, user } = props;

  const typeformId = useMemo(() => extractTypeformId(lesson?.typeformUrl), [lesson?.typeformUrl]);

  const hidden = useMemo(() => {
    return {
      name: user?.name,
      email: user?.email,
      first_name: user?.firstName,
      user_id: user?.id,
      lesson_id: lesson?.id,
    };
  }, [user?.id, user?.name, user?.email, user?.firstName, lesson?.id]);
  
  if (!lesson || !lesson.typeformUrl || !typeformId) return null;

  return (
    <LessonTypeformSurvey typeformId={typeformId} hidden={hidden} />
  );
}

function mapStateToProps(state, ownProps) {
  const { lessonId } = ownProps;

  return {
    lesson: getCurrentLesson(state, lessonId),
    user: getCurrentUser(state),
    lessonId,
  };
}

export default connect(mapStateToProps)(LessonTypeformSurveyContainer);
